import { RevenueExpensesData } from '../../../../../../types/apiTypes';

/**
 * Average monthly revenue over the previous 60 days. The series is chronological
 * ascending; we exclude the current (partial) month and average the two most
 * recent completed months. Returns 0 when there isn't enough history.
 *
 * Shared by the Home and Banking Overview pages so the "vs prev 60-day avg"
 * comparison in BalancesWidget stays identical across both.
 */
export const getPrev60DayAvgRevenue = (data: RevenueExpensesData[]): number => {
  if (!Array.isArray(data) || data.length < 2) return 0;
  // The series uses two month encodings depending on its source: the backend chart
  // endpoint emits 1-indexed, zero-padded "MM" (e.g. "06"), while demo data emits
  // 0-indexed, unpadded getMonth() (e.g. "5"). Match the current month in both
  // encodings so the partial current month is reliably excluded either way.
  const now = new Date();
  const currentMonthTokens = new Set([
    now.getMonth().toString(), // demo: "5"
    String(now.getMonth() + 1).padStart(2, '0'), // backend: "06"
  ]);
  const completedMonths = data.filter(
    (item) => !currentMonthTokens.has(item?.month)
  );
  const prevTwoMonths = completedMonths.slice(-2);
  if (prevTwoMonths.length < 2) return 0;
  const total = prevTwoMonths.reduce(
    (sum, item) => sum + (item?.revenue || 0),
    0
  );
  return total / prevTwoMonths.length;
};
